const repositoryName = 'inventory-mf-ui';
const repositoryNamePrefix = repositoryName.slice(0, -3);
const route = `/${repositoryNamePrefix}/demo`;
export { repositoryName, repositoryNamePrefix, route };
